// widget style
import styled, { keyframes } from 'styled-components';
import { fadeInUp, fadeIn } from 'react-animations';
import Inquiry from '../../inquiry/Inquiry';

const keyframeFadeInUp = keyframes`${fadeInUp}`;
export const fadeInUpComponent = Node =>
  styled(Node)`
    animation: 0.8s ${keyframeFadeInUp};
  `;

// export const fadeInUpComponent = Node =>
//   styled(Node)`
//     animation: ${props => (props.motion ? `0.8s ${keyframeFadeInUp}` : 'none')};
//   `;

const keyframeFadeIn = keyframes`${fadeIn}`;
// export const fadeInComponent = Node =>
//   styled(Node)`
//     animation: 0.8s ${keyframeFadeIn};
//   `;
//
//
// export const FadeInUp = styled(Inquiry)`
//   animation: 0.8s ${keyframeFadeInUp};
// `
//
// export const FadeIn = styled(Inquiry)`
//   animation: 0.8s ${keyframeFadeIn};
// `

export const InquiryMotion = styled(Inquiry)`
  ${props =>
    props.motion === 'up'
      ? `animation: 0.8s ${keyframeFadeInUp}`
      : props.motion === 'in'
      ? `animation: 0.8s ${keyframeFadeIn}`
      : ''};
`;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/widget/style/index.js